
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSQuotationLaborGrid extends Serenity.EntityGrid<POSQuotationLaborRow, any> {
        protected getColumnsKey() { return 'Retail.QuotationLabor'; }
        protected getIdProperty() { return POSQuotationLaborRow.idProperty; }
        protected getInsertPermission() { return POSQuotationLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return POSQuotationLaborRow.localTextPrefix; }
        protected getService() { return POSQuotationLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}